module.exports = __webpack_public_path__ + "img/location@3x.9b20eda0.png";